// @flow

import { jsx } from '@emotion/core';

import { isolateCss, stylesResetAttribute } from './isolateCss';

// Function and `class` components will be functions, whereas
// HTML elements like `div` will be strings.
const isComponent = type => {
  return typeof type === 'function';
};

const isFragment = type => {
  return typeof type === 'symbol';
};

const svgNodes = new Set(['path', 'rect', 'ellipse', 'circle', 'g']);
const isSvgNode = type => {
  return svgNodes.has(type);
};

// $FlowFixMe
const isolateComponent = (type, props, ...children) => {
  if (!type) {
    return jsx(type, props, ...children);
  }
  // Don't add `stylesResetAttribute` to components since
  // they won't accept `stylesResetAttribute` as a prop.
  // Also don't add to SVG subnodes since resetting them
  // can unset some of their attributes.
  // Only add it to HTML elements.
  if (!isComponent(type) && !isFragment(type) && !isSvgNode(type)) {
    props = { ...(props || {}), [stylesResetAttribute]: true };
  }
  // If there's a `css` prop then `isolateCss` it to
  // ensure its specificity is high enough to overtake
  // the reset styles.
  if (props && props.css) {
    props.css = isolateCss(props.css);
  }
  return jsx(type, props, ...children);
};

export default isolateComponent;
